import styled from 'styled-components';
import { breakpoints } from 'design-system/src/tokens/breakpoints';

export const PAGE_PADDING = 16;
export const START_STEP_DESKTOP_MIN_HEIGHT = 423;

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  background: var(--surface-200);
  padding: ${PAGE_PADDING}px;
  flex-direction: column;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.mobileMax}px) {
    padding: 12px;
  }
`;

export const ContainerAtTop = styled.div`
  position: fixed;
  top: 16px;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
`;

export const DesktopContainer = styled.div<{ alignment?: 'flex-start' | 'flex-end' }>`
  width: 100%;
  align-items: ${({ alignment }) => alignment || 'center'};
  justify-content: center;
  flex-direction: column;
  display: flex;
  @media (max-width: ${breakpoints.mobileMax}px) {
    display: none;
  }
`;

export const DesktopInlineContainer = styled.div`
  @media (max-width: ${breakpoints.mobileMax}px) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.tabletMin}px) {
    display: none;
  }
`;

export const MobileInlineContainer = styled.div`
  @media (min-width: ${breakpoints.tabletMin}px) {
    display: none;
  }
`;

const DESKTOP_SIGNUP_FORM_GAP = 16;
const MOBILE_SIGNUP_FORM_GAP = 8;

export const StyledSignupForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${DESKTOP_SIGNUP_FORM_GAP}px;
  width: 100%;

  @media (max-width: ${breakpoints.mobileMax}px) {
    gap: ${MOBILE_SIGNUP_FORM_GAP}px;
  }
`;

export const NameRow = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: ${breakpoints.mobileMax}px) {
    flex-direction: column;
    gap: ${MOBILE_SIGNUP_FORM_GAP}px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  align-items: flex-start;

  @media (max-width: ${breakpoints.mobileMax}px) {
    gap: 20px;
  }
`;

export const CardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${breakpoints.mobileMax}px) {
    gap: 12px;
  }
`;

export const CardSubSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;

  @media (max-width: ${breakpoints.mobileMax}px) {
    gap: 6px;
  }
`;

export const StyledCheckboxRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;

  @media (max-width: ${breakpoints.mobileMax}px) {
    margin-top: 4px;
    gap: 4px;
  }
`;

export const StyledCheckboxItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin-top: 32px;
  justify-content: center;
`;

export const ComplianceIcon = styled.img`
  height: 32px;
`;
